import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, Collapse, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { DateView } from 'src/core/ui/date.view';
import { TextView } from 'src/core/ui/text.view';
import { IdentityService } from 'src/core/services/identity.service';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
const Panel = Collapse.Panel;
import { observable, isArrayLike } from 'mobx';
import { VisibilityEditorView } from 'src/app/shared/parts/visibility-editor.view';
interface ErrataListViewProps extends ComponentViewProps<ErrataItem[]> {
	readOnly?: boolean;
	parentMode: ControlMode;
	identityService: IdentityService;
	deleteErrata: (errata: ErrataItem) => void;
	addErrata?: () => void;
}

@observer
export class ErrataListView extends React.Component<ErrataListViewProps, {}> {
	constructor(props: Readonly<ErrataListViewProps>) {
		super(props);
	}
	defaultActiveKey = [];
	@observable
	collapseKeys = [];
	public optionsVisibility = [
		{ value: 'Document', label: 'Document' }
	];
	onchangePanel = (key: string | string[]) => {
		if (isArrayLike(key)) {
			this.collapseKeys = this.defaultActiveKey.filter(k => !key.some(x => x == k));

		}
		else {
			if (key != null || key != '')
				this.collapseKeys = this.defaultActiveKey.filter(k => key != k);
		}

	}
	rendenChildErrata = (errata: ErrataItem) => {
		const mode = this.props.parentMode;

		return (
			<div>
				<Button.Group>
					<Button
						icon="delete"
						disabled={errata.userName != this.props.identityService.username || mode === 'display'}
						onClick={() => this.props.deleteErrata(errata)}
					>
						Delete
					</Button>
				</Button.Group>
				<Row gutter={16}>
					<Col xs={24} lg={6}>
						<TextView
							mode={mode}
							label="Title"
							value={errata.title}
							placeholder="Enter a title..."
							onChanged={newVal => { errata.title = newVal; this.forceUpdate(); }}
						/>
					</Col>
					<Col xs={24} lg={6}>
						<VisibilityEditorView
							required
							disabled={this.props.parentMode == 'display' ? true : false}
							label="Visibility:"
							model={errata.visibility}
						/>
					</Col>
					<Col xs={24} lg={6}>
						<TextView
							mode="display"
							label='User'
							value={errata.userName}
						/>
					</Col>
					<Col xs={24} lg={6}>
						<DateView
							label="Creation Date"
							mode={'display'}
							value={errata.creationDate}
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} lg={6}>
						<DateView
							label="Booking Start Date"
							mode={mode}
							value={errata.bookingStartDate}
							onChanged={newVal => { errata.bookingStartDate = newVal; }}
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
					<Col xs={24} lg={6}>
						<DateView
							label="Booking End Date"
							mode={mode}
							value={errata.bookingEndDate}
							onChanged={newVal => { errata.bookingEndDate = newVal; }}
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
					<Col xs={24} lg={6}>
						<DateView
							label="Service Start Date"
							mode={mode}
							value={errata.serviceStartDate}
							onChanged={newVal => { errata.serviceStartDate = newVal; }}
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
					<Col xs={24} lg={6}>
						<DateView
							label="Service End Date"
							mode={mode}
							value={errata.serviceEndDate}
							onChanged={newVal => { errata.serviceEndDate = newVal; }}
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={24}>
						<RichTextView
							containerClassName="wysiwyg-editor-wrap-content"
							label="Errata Text"
							value={errata.html}
							onChanged={(html) => { errata.html = html }}
							mode={mode}
						/>
					</Col>
				</Row>
			</div>
		);
	}

	render() {
		const { model, readOnly, parentMode, addErrata } = this.props;
		if (model == null) {
			return null;
		}

		const collapseNote = [];
		 this.defaultActiveKey = [];
		for (const errata of model) {
			this.defaultActiveKey.push(errata.id);
			collapseNote.push(
				<Panel
					header={errata.title || "Enter a title..."}
					key={errata.id}
				>
					{this.rendenChildErrata(errata)}
				</Panel>
			);
		}
		let activesKeys = this.defaultActiveKey.filter(k => !this.collapseKeys.some(x => x == k));
		return (
			<div>
				{!readOnly &&
					<Button
						key="add"
						type="primary"
						icon="plus"
						style={{ marginBottom: '5px' }}
						disabled={parentMode === 'display'}
						onClick={() => {
							addErrata();
						}}
					>
						Add
					</Button>
				}
				<Collapse
					bordered={false}
					activeKey={activesKeys}
					onChange={this.onchangePanel}
				>
					{collapseNote}
				</Collapse>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/erratas/list/errata-list.view.tsx